"use client";

import { NpsQuestionSet, NpsScoreBucket } from "@/types/nps";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { NPS_MAX_FEEDBACK_LENGTH } from "@/utils/nps/normalize";

type NpsFeedbackStepProps = {
  questions: NpsQuestionSet;
  bucket: NpsScoreBucket;
  feedback: string;
  disabled?: boolean;
  onBack: () => void;
  onClose: () => void;
  onFeedbackChange: (feedback: string) => void;
  onSubmit: () => void;
};

export default function NpsFeedbackStep({
  questions,
  bucket,
  feedback,
  disabled = false,
  onBack,
  onClose,
  onFeedbackChange,
  onSubmit,
}: NpsFeedbackStepProps) {
  const question = questions[bucket];

  return (
    <Card className="w-full max-w-xl border-300 shadow-2xl">
      <CardHeader className="flex-row items-start justify-between gap-4 space-y-0">
        <CardTitle className="text-base leading-6">{question}</CardTitle>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          aria-label={questions.close}
          onClick={onClose}
        >
          x
        </Button>
      </CardHeader>
      <CardContent className="space-y-2">
        <Textarea
          value={feedback}
          maxLength={NPS_MAX_FEEDBACK_LENGTH}
          placeholder={questions.placeholder}
          disabled={disabled}
          onChange={(event) => onFeedbackChange(event.target.value)}
        />
        <p className="text-right text-xs text-600">
          {questions.characterCount.replace("{{count}}", String(feedback.length))}
        </p>
      </CardContent>
      <CardFooter className="justify-between gap-3">
        <Button type="button" variant="ghost" disabled={disabled} onClick={onBack}>
          {questions.back}
        </Button>
        <div className="flex gap-2">
          <Button type="button" variant="outline" disabled={disabled} onClick={onClose}>
            {questions.skip}
          </Button>
          <Button type="button" disabled={disabled} onClick={onSubmit}>
            {questions.submit}
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
}
